const data = [
    {
      id: 1,
      image: "https://img.icons8.com/external-smashingstocks-detailed-outline-smashing-stocks/66/null/external-digital-marketing-shopping-and-ecommerce-smashingstocks-detailed-outline-smashing-stocks.png",
      title: "Business Stratagy",
      desc: "Grow your business with the best strategy in less time and at lower cost.",
    },
    {
      id: 2,
      image: "https://img.icons8.com/ios/50/null/google-code.png",
      title: "App Development",
      desc: " Our team offers you tailor-made solutions adapted to your company and your objectives: creation of e-commerce sites from A to Z with functionalities of any complexity, integration with API & ERP systems.",
    },
    {
      id: 3,
      image: "https://img.icons8.com/external-smashingstocks-detailed-outline-smashing-stocks/66/null/external-app-development-ui-ux-user-interface-smashingstocks-detailed-outline-smashing-stocks.png ",
      title: "Mobile App",
      desc: "Creating strategic mobile solutions that deliver tangible business results, Mogaprod's mobile application development services help brands navigate all facets of the digital landscape.",
    },
    {
      id: 4,
      image: "https://img.icons8.com/external-linector-lineal-linector/64/null/external-social-media-marketing-seo-marketing-linector-lineal-linector.png ",
      title: "Social Media Marketing",
      desc: "Increase your audiences, your sales, your interactions on all your social networks.",
    },
    {
      id: 5,
      image: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/64/null/external-seo-marketing-and-seo-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto-2.png ",
      title: "SEO Marketing",
      desc: "Improve your website's ranking in the Google search engine and increase your sales with our advanced SEO services.",
    },
    {
      id: 6,
      image: "https://img.icons8.com/ios-filled/50/null/compact-camera.png ",
      title: "Shooting Poducts",
      desc: " Fashion evolves, changes constantly, you have to adapt your photos to trends and current events. Vary your images, display your photogenicity with Mogaprod.",
    },
  ]
  export default data